import con from '../../../../connection';
var path = '/files';
var files = function (url) { return function (token) { return ({
    // ファイルダウンロード
    get: function (param, noError, timeoutMS) { return con.getFile(url + "/" + token + path, param || {}, noError, timeoutMS); },
    // ファイルアップロード
    post: function (param, noError, timeoutMS) { return con.post(url + "/" + token + path, param, noError, timeoutMS); },
}); }; };
export default files;
